<template>
    <div class="app-container">
        <jf-table
            :loading="loading"
            :columns="tableColumn"
            :data="dataList"
            :toolbar-config="tableToolbar"
            :query-params="queryParams"
            @page-change="handlePageChange"
            :total="total"
            @change="tableChange"
            @handleQuery="handleQuery"
            :operate="false"
            :checkbox="false"
        >
            <template slot="query_qarams_item">
                <el-form-item label="学生" prop="student_no">
                    <student-select
                        v-model="queryParams.student_no"
                        placeholder="请选择学生"
                        valueField="no"
                        size="small"
                    />
                </el-form-item>
            </template>
            <!--
            <template slot="toolbar_btn_left">
                <el-button
                    class="btn-orange"
                    size="mini"
                    @click="handleExport"
                    v-hasPermi="['/stuc/stucurriculumscorewarn/export']"
                >
                    <i class="iconfont icon-daochu_o"></i>
                    导出
                </el-button>
            </template>
            -->
        </jf-table>
    </div>
</template>
<script>
import Qs from "qs";
import {
    listStuCurriculumScoreWarning,
} from "@/api/stuc/stu_curriculum_score";
export default {
    name: "stuc-stucurriculumscorewarn-list",
    data() {
        var ret = {
            tableToolbar: {
                perfect: false,
                zoom: true,
                custom: false,
                refresh: {
                    query: this.handleQuery,
                },
                slots: {
                    buttons: "toolbar_buttons",
                },
            },
            tableColumn: [
                { field: "student_no", title: "学号", minWidth: 80 },
                { field: "student_name", title: "姓名", minWidth: 40 },
            ],
            loading: true,
            ids: [],
            single: true,
            multiple: true,
            total: 0,
            dataList: [],
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                id: undefined,
                dept_no: undefined,
                major_no: undefined,
                grade: undefined,
            },
        };

        this.getDicts("stuc_course_category").then((response) => {
            if (response.code == 0) {
                var dictData = response.data.values;

                dictData.forEach(element => {
                    ret.tableColumn.push({ title: element.value, minWidth: 80, index: element.key, formatter: this.categoryFormat});
                });
            }
        });

        return ret;
    },
    created() {
        this.getList();
    },
    methods: {
        //列表的筛选和排序
        tableChange(e) {},
        getList() {
            this.loading = true;
            this.ids = [];
            this.single = true;
            this.multiple = true;

            listStuCurriculumScoreWarning(this.queryParams).then((response) => {
                this.dataList = response.data.list;
                this.total = response.data.total;
                this.loading = false;
            });
        },

        categoryFormat(e) {
            const col = this.tableColumn[e.columnIndex];
            var index = col.index;
            var value = e.row.credits? e.row.credits[index]: "0.0";
            var requirement = e.row.requirements? e.row.requirements[index]: "0.0";
            value = value? value.toFixed(1): "0.0";
            requirement = requirement? requirement.toFixed(1): "0.0";
            
            return value + " / " + requirement;
        },

        handleQuery(e) {
            if(e) {
                this.queryParams = this.deepCopy(e);
            };
            this.queryParams.pageNum = 1;
            this.getList();
        },

        resetQuery() {
            this.resetForm("queryForm");
            this.handleQuery();
        },

        handlePageChange({ currentPage, pageSize }) {
            if (this.queryParams.pageSize == pageSize) {
                this.getList();
            } else {
                this.queryParams.pageSize = pageSize;
                this.handleQuery();
            }
        },

        handleExport() {
            this.$confirm("确定导出数据吗?", "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.downloadbyurl(
                    "/stuc/stucurriculumscore/warn_export?" + Qs.stringify(this.queryParams)
                );
            });
        },
    },
};
</script>
